<script type="text/babel">
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'
import HasPagination from 'dashboard-js/mixins/HasPagination'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    mixins: [HasLoadingState, HasPagination, RestoreOnPageBack],

    data() {
        return {
            jobs: {},
        }
    },

    computed: {
        params() {
            return {
                page: this.page,
            }
        },
    },

    created() {
        this.onPageVisit(() => {
            this.page = 1
            this.load()
        })
    },

    methods: {
        load() {
            axios
                .get(route('api.profile.jobs'), { params: this.params })
                .then(response => {
                    this.jobs = this.paginate(response.data)
                })
                .then(this.finishLoading())
                .then(this.saveState)
        },
    },
}
</script>
